(function($) {
    var timer;
    var exitintent;
    var exitIntentCloseBtn;

    function trackLeave(ev) {
        if (ev.pageY > 0) {
            return;
        }

        if (timer) {
            clearTimeout(timer);
        }

        if ($.exitIntent.settings.sensitivity <= 0) {
            $.event.trigger('exitintent');
            return;
        }

        timer = setTimeout(
            function() {
                timer = null;
                $.event.trigger('exitintent');
            }, $.exitIntent.settings.sensitivity);
    }

    function trackEnter() {
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
    }

    function exitIntentClose() {
        $("body").removeClass('exitintent');
        exitintent.hide();
        exitIntentCloseBtn.hide();
    }

    $.exitIntent = function(enable, options) {
        $.exitIntent.settings = $.extend($.exitIntent.settings, options);

        if (enable == 'enable') {
            $(window).mouseleave(trackLeave);
            $(window).mouseenter(trackEnter);
        } else if (enable == 'disable') {
            trackEnter(); // Turn off any outstanding timer
            $(window).unbind('mouseleave', trackLeave);
            $(window).unbind('mouseenter', trackEnter);
        } else {
            throw "Invalid parameter to jQuery.exitIntent -- should be 'enable'/'disable'";
        }
    }

    $.exitIntent.settings = {
        'sensitivity': 300
    };

    if ($(".js-exitintent").length > 0) {
        $.exitIntent('enable');
        $(document).bind('exitintent', function() {
            exitintent = $(".js-exitintent");

            exitIntentCloseBtn = $('<span>').addClass('exitintent-close close-icon').click(function() {
                exitIntentClose();
            })

            $("body")
                .addClass('exitintent')
                .append(exitIntentCloseBtn);

            exitintent.fadeIn();

            $('html').click(function() {
                if ($("body").hasClass('exitintent')) {
                    exitIntentClose();
                }
            });

            exitintent.click(function(event) {
                event.stopPropagation();
            });

            $.exitIntent('disable');
        });


    }



})(jQuery);
